import React from 'react';

const AssignDriverIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 3.75C9.10875 3.75 6.75 6.10875 6.75 9C6.75 10.8075 7.6725 12.4125 9.0705 13.3597C6.39525 14.5072 4.5 17.1622 4.5 20.25H6C5.99905 19.2247 6.26154 18.2163 6.7623 17.3215C7.26306 16.4268 7.9853 15.6757 8.85975 15.1403C9.1159 15.763 9.55096 16.2958 10.1099 16.6714C10.6689 17.0469 11.3266 17.2483 12 17.25C12.6735 17.2484 13.3314 17.0471 13.8905 16.6716C14.4496 16.296 14.8848 15.7631 15.141 15.1403C16.0153 15.6758 16.7374 16.4269 17.238 17.3216C17.7386 18.2164 18.001 19.2247 18 20.25H19.5C19.5 17.1622 17.6047 14.508 14.9295 13.359C15.6432 12.8775 16.2279 12.2284 16.6325 11.4684C17.037 10.7085 17.2491 9.86092 17.25 9C17.25 6.10875 14.8912 3.75 12 3.75ZM12 5.25C14.0798 5.25 15.75 6.92025 15.75 9C15.75 11.0798 14.0798 12.75 12 12.75C9.92025 12.75 8.25 11.0798 8.25 9C8.25 6.92025 9.92025 5.25 12 5.25ZM12 14.25C12.615 14.251 13.201 14.337 13.758 14.508C13.6299 14.872 13.392 15.1872 13.0771 15.4101C12.7622 15.6331 12.3858 15.7529 12 15.7529C11.6142 15.7529 11.2378 15.6331 10.9229 15.4101C10.608 15.1872 10.3701 14.872 10.242 14.508C10.8119 14.3352 11.4044 14.2483 12 14.25Z'
        fill='#41415A'
      />
    </svg>
  );
};

export default AssignDriverIcon;
